import './seo-text.css';

export default (element, data) => {};